import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Image } from "cloudinary-react";

const ShowImageForAdmin = ({ source, handleRemoveImage }) => {
  return (
    <Row className="d-flex justify-content-start">
      {source.slice(0, 6).map((item, index) => (
        <Col key={index} xs={6} md={6} className="p-2 d-flex flex-column">
          <div className="d-flex align-items-center">
            {item.url.startsWith("data:image") ? (
              // Display Base64 Image
              <img
                src={item.url}
                alt={item.name}
                width="200"
                height="200"
                style={{
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            ) : (
              // Display Cloudinary Image
              <Image
                className="img-lg"
                cloudName="dljielsye"
                publicId={item.url}
                width="200"
                height="200"
                style={{
                  objectFit: "contain",
                  borderRadius: "8px",
                }}
              />
            )}

            {/* Remove Button */}
            {handleRemoveImage && source.length > 1 && (
              <Button
                variant="danger"
                className="btn-sm ms-2"
                onClick={() => handleRemoveImage(index)}
              >
                <i className="fas fa-times" />
              </Button>
            )}
          </div>
          <div className="text-muted text-start">{item.name}</div>
        </Col>
      ))}
    </Row>
  );
};

export default ShowImageForAdmin;
